module.exports = __webpack_public_path__ + "media/images/flags/64/Turks-and-Caicos-Islands-7a5ce1279c21793319375227d8b66885.png";